import { Card } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

import ModelBreadcrumbs from '../../../components/ModelBreadcrumbs';
import BasicLayout from '../../../layouts/BasicLayout';
import { EmergencyScenarioForm } from '../components/EmergencyScenarioForm';
import { EmergencyScenarioModel } from '../model';

export const EmergencyScenarioCreatePage: React.FC<any> = () => {
  const history = useHistory();

  return (
    <BasicLayout pageTitle='Create Emergency Scenario'>
      <Card
        title={<ModelBreadcrumbs model={EmergencyScenarioModel} rowBreadCrumb={{ isNew: true }} />}
        bordered={false}
        style={{ marginBottom: 20 }}
      >
        <EmergencyScenarioForm
          isNew
          onCancel={() => history.goBack()}
          onSubmit={(emergencyScenarioId) => {
            history.push(`/emergency-scenarios/details/${emergencyScenarioId}`)
          }}
        />
      </Card>
    </BasicLayout>
  );
};
